import React from "react";
import { RiBuilding2Line } from "react-icons/ri";

const Bookings = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primaryTextColor via-secondaryTextColor to-primaryBtnHoverColor text-white overflow-hidden mb-12">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute top-0 left-0 w-full h-full bg-repeat"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M30 30v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 54v-4H4v4H0v2h4v4h2v-4h4v-2H6zM54 6V0h-2v6h-4v2h4v4h2V6h4V4h-4z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        ></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-12">
        <div className="text-center max-w-6xl mx-auto">
          {/* Coming Soon GIF and Bookings Image */}
          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Coming Soon GIF */}
            <div className="w-full md:w-1/2 max-w-md">
              <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-6 border border-gray-700 shadow-2xl">
                <img
                  src="https://i.pinimg.com/originals/ae/ac/7d/aeac7d920f81b2584e9ac657685ced30.gif"
                  alt="Cricket Coaching Camp"
                  className="w-full h-64 object-cover rounded-xl"
                />
                <p className="text-lg font-semibold mt-4 tracking-wide text-primaryBtnHoverColor">
                  Cricket Coaching Camp!
                </p>
              </div>
            </div>

            {/* Bookings Image */}
            <div className="w-full md:w-1/2 max-w-md">
              <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-6 border border-gray-700 shadow-2xl">
                <img
                  src="https://media1.giphy.com/media/v1.Y2lkPTZjMDliOTUyZGF5dmVvcW5ib256N2ZkbzZ6OHUydXVsajhsc2dldXo1bWo3N3d3ZiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/fq7UeXsc8f2ZlNzCf7/giphy.gif"
                  alt="Coaching Pro"
                  className="w-full h-64 object-cover rounded-xl"
                />
                <p className="text-lg font-semibold mt-4 tracking-wide text-primaryBtnHoverColor">
                  Coaching Pro!
                </p>
              </div>
            </div>
          </div>

          {/* Logo/Brand */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-gradient-to-br from-primaryBtnColor to-primaryBtnHoverColor rounded-2xl flex items-center justify-center shadow-lg mx-auto mb-4">
              <RiBuilding2Line className="text-white text-4xl" />
            </div>
            <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4 bg-gradient-to-r from-primaryBtnHoverColor to-primaryBtnColor bg-clip-text text-transparent">
              Book Now
            </h1>
            <p className="text-xl md:text-2xl font-subheading text-gray-300">
              Community • Collaboration • Creativity
            </p>
          </div>

          {/* Coming Soon Message */}
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6">
              Club Management Coming Soon
            </h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
              We're building a centralized hub for managing clubs, activities,
              and members. Stay tuned for tools that simplify collaboration and
              amplify creativity within your community.
            </p>
          </div>

          {/* Features Grid */}
          <div className="mb-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-gray-800 bg-opacity-30 rounded-xl p-6 border border-gray-700">
                <div className="w-16 h-16 bg-primaryBtnColor rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">👥</span>
                </div>
                <h3 className="text-xl font-bold mb-2">Member Management</h3>
                <p className="text-gray-300">
                  Easy member onboarding and management
                </p>
              </div>
              <div className="bg-gray-800 bg-opacity-30 rounded-xl p-6 border border-gray-700">
                <div className="w-16 h-16 bg-primaryBtnColor rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">📅</span>
                </div>
                <h3 className="text-xl font-bold mb-2">Event Planning</h3>
                <p className="text-gray-300">
                  Schedule and organize club events
                </p>
              </div>
              <div className="bg-gray-800 bg-opacity-30 rounded-xl p-6 border border-gray-700">
                <div className="w-16 h-16 bg-primaryBtnColor rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">💬</span>
                </div>
                <h3 className="text-xl font-bold mb-2">Collaboration</h3>
                <p className="text-gray-300">Seamless communication tools</p>
              </div>
            </div>
          </div>

          {/* Simple CTA Placeholder */}
          <div className="mt-8">
            <button className="px-8 py-4 rounded-xl bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white font-semibold text-lg shadow-lg hover:scale-105 transition-transform duration-300">
              Stay Notified 🚀
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bookings;
